import React, { useState } from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, CheckIcon, MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { advisor, dealership } from '../data/catalog';
import { NEWSLETTER_WEBHOOK, postToWebhook, track } from '../config/site';
import { Reveal } from './Reveal';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../contexts/LanguageContext';

// Los perfiles reales van aqui. Mientras esten vacios, los iconos
// llevan al formulario de contacto en vez de a un link roto.
const socials = [{
  label: 'Instagram',
  Icon: InstagramIcon,
  href: ''
}, {
  label: 'Facebook',
  Icon: FacebookIcon,
  href: ''
}, {
  label: 'YouTube',
  Icon: YoutubeIcon,
  href: ''
}, {
  label: 'LinkedIn',
  Icon: LinkedinIcon,
  href: ''
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [sending, setSending] = useState(false);
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || sending) return;
    setSending(true);
    track('Subscribe', {
      content_category: 'Newsletter'
    });
    await postToWebhook(NEWSLETTER_WEBHOOK, {
      email,
      tipo: 'newsletter'
    });
    setSending(false);
    setSubscribed(true);
    setEmail('');
  };
  return <footer id="informacion" className="scroll-mt-24 border-t border-line bg-canvas" data-id="element-61" data-mp="3q7bz8ba5lhjl">
      {/* Bloque de contacto del concesionario */}
      <div className="mx-auto max-w-[1520px] px-5 py-16 sm:px-6 sm:py-24 lg:px-14 lg:py-28" data-id="element-62" data-mp="34723g4s9vvk">
        <Reveal data-id="element-63" data-mp="hsk4auugsayi">
          <div className="grid grid-cols-1 gap-10 border-b border-line pb-14 sm:gap-14 sm:pb-20 lg:grid-cols-3 lg:gap-16" data-id="element-64" data-mp="ht3ajear5awp">
            <div data-id="element-65" data-mp="cv1r2s9ez9kp">
              <p className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-mute" data-id="element-66" data-mp="cuiiw39kfzjv">
                <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="qrf9c3lrvf08" />
                {t.footer.addressLabel}
              </p>
              <address className="mt-6 text-xl font-light not-italic leading-relaxed text-white lg:text-2xl" data-id="element-68" data-mp="tv4iroyaqfyo">
                15055 Biscayne Blvd
                <br data-id="element-69" data-mp="yuzdk3l6zpp0" />
                North Miami, FL 33181
              </address>
              <a href="https://maps.google.com/?q=15055+Biscayne+Blvd+North+Miami+FL" target="_blank" rel="noreferrer" onClick={() => track('FindLocation')} className="link-underline mt-6 inline-block text-[13px] text-mute transition-colors duration-500 ease-[var(--ease-lux)] hover:text-white" data-id="element-70" data-mp="13s9as5etp5ne">
                {t.footer.directions}
              </a>
            </div>

            <div data-id="element-71" data-mp="1riv4ero2yndv">
              <p className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-mute" data-id="element-72" data-mp="1rjep2g547pvl">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="3obwzv73o0ms8" />
                {t.footer.hoursLabel}
              </p>
              <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-74" data-mp="3tb1a812bsqk5">
                {t.footer.hours.map(slot => <li key={slot.days} className="flex items-baseline justify-between gap-6 py-3.5" data-id="element-75" data-mp="2ah86t0ymzixm">
                    <span className="text-[13px] text-white/85" data-id="element-76" data-mp="25mao12bk1v7j">{slot.days}</span>
                    <span className="text-[13px] font-light text-mute" data-id="element-77" data-mp="21n1tvwclrvbg">{slot.time}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-78" data-mp="2te9dcq7u9r3o">
              <p className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-mute" data-id="element-79" data-mp="2tcojz3x9ge7e">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="2pcw5ybp3lfun" />
                {t.footer.phoneLabel}
              </p>
              <a href={advisor.phoneHref} onClick={() => track('Contact', {
              method: 'phone'
            })} className="mt-6 block text-xl font-light text-white transition-colors duration-500 ease-[var(--ease-lux)] hover:text-guards-bright lg:text-2xl" data-id="element-81" data-mp="2kfe4f6deu2wo">
                {advisor.phoneLabel}
              </a>
              <a href={advisor.emailHref} onClick={() => track('Contact', {
              method: 'email'
            })} className="link-underline mt-3 inline-block break-all text-[14px] text-mute transition-colors duration-500 ease-[var(--ease-lux)] hover:text-white" data-id="element-82" data-mp="2ruoh999siq0h">
                {advisor.email}
              </a>
              <p className="mt-4 max-w-xs text-[13px] font-light leading-relaxed text-mute" data-id="element-83" data-mp="3bjqiiqxrlxla">
                {t.footer.advisorNote(advisor.name, t.lead.advisorRole, dealership.phoneLabel)}
              </p>
              <a href="#contacto" className="btn-glint btn-glint-sheen btn-halo-red mt-8 inline-flex items-center bg-guards px-8 py-3.5 text-[13px] font-medium tracking-wide text-white hover:bg-guards-bright" data-id="element-84" data-mp="31lsw88zguavb">
                <span data-id="element-85" data-mp="1q52kybg6qsuu">{t.footer.testDrive}</span>
              </a>
            </div>
          </div>
        </Reveal>

        {/* Enlaces y newsletter */}
        <div className="mt-14 grid grid-cols-2 gap-10 sm:mt-20 sm:gap-16 lg:grid-cols-[1.3fr_repeat(3,0.8fr)_1fr]" data-id="element-86" data-mp="1nlfzpmp1putd">
          <div className="col-span-2 lg:col-span-1" data-id="element-87" data-mp="1iltcckfi6y6u">
            <h2 className="text-[11px] uppercase tracking-[0.24em] text-mute" data-id="element-88" data-mp="1ip7cdm0p2vb4">
              {t.footer.newsletter}
            </h2>
            <p className="mt-5 max-w-xs text-lg font-light leading-relaxed text-white" data-id="element-89" data-mp="1rnb10r6z8875">
              {t.footer.newsletterCopy}
            </p>
            <form onSubmit={onSubmit} className="mt-8 flex max-w-sm items-stretch" data-id="element-90" data-mp="13y88goat0uxv">
              <label htmlFor="newsletter-email" className="sr-only" data-id="element-91" data-mp="zxy57jeecimp">
                {t.footer.emailPlaceholder}
              </label>
              <input id="newsletter-email" type="email" required value={email} onChange={e => {
              setEmail(e.target.value);
              setSubscribed(false);
            }} placeholder={t.footer.emailPlaceholder} className="min-w-0 flex-1 border border-line bg-canvas px-4 py-3 text-[13px] text-white placeholder:text-mute focus:border-white focus:outline-none" data-id="element-92" data-mp="1dpmihq0dtd59" />
              <button type="submit" disabled={sending} className="btn-glint btn-glint-sheen btn-halo-red bg-guards px-7 py-3 text-[13px] font-medium tracking-wide text-white hover:bg-guards-bright disabled:cursor-wait disabled:opacity-70" data-id="element-93" data-mp="2q0oz51ojljiv">
                <span data-id="element-94" data-mp="22ambqyvkp1ql">{sending ? '…' : t.footer.subscribe}</span>
              </button>
            </form>
            {subscribed && <p role="status" className="mt-4 flex items-center gap-2 text-[13px] text-white" data-id="element-95" data-mp="2795y30e2wfjh">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="2bcbxbo2rx6gg" />
                {t.footer.subscribed}
              </p>}
          </div>

          {t.footer.columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-97" data-mp="3mpeeak8sby15">
              <h2 className="text-[11px] uppercase tracking-[0.24em] text-mute" data-id="element-98" data-mp="1b3vrr2iacu9b">{column.title}</h2>
              <ul className="mt-6 space-y-4" data-id="element-99" data-mp="1718v8oao6l5s">
                {column.links.map(link => <li key={link} data-id="element-100" data-mp="12asiz7il55l0">
                    <a href="#contacto" className="link-underline text-[13px] text-white/80 transition-colors duration-500 ease-[var(--ease-lux)] hover:text-white" data-id="element-101" data-mp="129r5kwe3k704">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </nav>)}

          <div className="col-span-2 lg:col-span-1" data-id="element-102" data-mp="jboco6ifhpx1">
            <h2 className="text-[11px] uppercase tracking-[0.24em] text-mute" data-id="element-103" data-mp="jcg558gqb7j3">{t.footer.follow}</h2>
            <ul className="mt-6 flex gap-3" data-id="element-104" data-mp="ef69vc6ns1nc">
              {socials.map(({
              label,
              Icon,
              href
            }) => <li key={label} data-id="element-105" data-mp="2do4odmtztw9a">
                  <a href={href || '#contacto'} {...href ? {
                target: '_blank',
                rel: 'noreferrer'
              } : {}} aria-label={label} onClick={() => href && track('Contact', {
                method: label.toLowerCase()
              })} className="flex h-10 w-10 items-center justify-center border border-line text-mute transition-colors duration-500 ease-[var(--ease-lux)] hover:border-white hover:text-white" data-id="element-106" data-mp="28ql0rwbeo74o">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="yvisajc9fe55" />
                  </a>
                </li>)}
            </ul>

            <p className="mt-10 text-[11px] uppercase tracking-[0.24em] text-mute" data-id="element-108" data-mp="12xnnhmicwitw">
              {t.languageLabel}
            </p>
            <LanguageToggle size="full" className="mt-4 w-fit" data-id="element-109" data-mp="ozfs3j0yxpku" />
          </div>
        </div>
      </div>

      <div className="border-t border-line" data-id="element-110" data-mp="ty0rxhcb678r">
        <div className="mx-auto flex max-w-[1520px] flex-col gap-3 px-6 py-7 text-[11px] tracking-wide text-mute sm:flex-row sm:items-center sm:justify-between lg:px-14" data-id="element-111" data-mp="2jc5oc7et7ave">
          <p data-id="element-112" data-mp="cmlrqhpadx63">
            © {new Date().getFullYear()} {dealership.name}. {t.footer.rights}
          </p>
          <ul className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-113" data-mp="7oaia82wlooe">
            {t.footer.legal.map(item => <li key={item} data-id="element-114" data-mp="mcwxm9sj6gfm">
                <a href="#contacto" className="link-underline transition-colors duration-500 ease-[var(--ease-lux)] hover:text-white" data-id="element-115" data-mp="me81sapw1q79">
                  {item}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}